export type Currency = 'EUR' | 'USD' | 'AUD' | 'JPY' | 'GBP';
